import BaseAPI from '@/apis/base'
import { apis, getApiUrl } from '../api-config'

class FileAPI extends BaseAPI {
}

const httpClient = new FileAPI('v1/files', 'File', getApiUrl(apis.FileAPI))

export { httpClient }
export default new FileAPI('v1/files', 'File', getApiUrl(apis.FileAPI))
